const features = [
  {
    icon: 'ri-4k-line',
    title: '1080P超高清画质',
    desc: '全站视频采用H.265高效编码，支持1080P超高清播放，每一帧画面都纤毫毕现。智能码率自适应，根据网络环境自动调节，确保流畅不缓冲。在6080新视觉影视，追剧就是享受。',
    items: ['H.265编码', '智能码率', '流畅播放'],
  },
  {
    icon: 'ri-timer-line',
    title: '每日同步更新',
    desc: '与电视台播出同步更新，热门剧集第一时间上线。更新速度快、剧集覆盖全，无论是最新热播剧还是经典老剧，都能在这里找到高清资源。追剧不再等待，精彩永远在线。',
    items: ['同步首播', '剧集齐全', '更新及时'],
  },
  {
    icon: 'ri-shield-check-line',
    title: '免费无广告体验',
    desc: '坚持免费观看的初心，无需注册、无需会员，打开即看。纯净的观看体验，没有烦人的弹窗广告和强制跳转，让追剧回归最简单的快乐。好剧，本该如此。',
    items: ['完全免费', '无需注册', '无弹窗广告'],
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="relative py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 mb-4">
            <i className="ri-star-line text-accent-400 text-xs"></i>
            <span className="text-accent-300 text-xs font-medium">平台优势</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            为什么选择我们
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            三大核心优势，重新定义在线追剧体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((feat, i) => (
            <div
              key={i}
              className="relative p-6 md:p-7 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 group cursor-default"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-200 transition-colors">
                <i className={`${feat.icon} text-primary-600 text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading font-bold text-lg md:text-xl text-foreground-900">
                {feat.title}
              </h3>
              <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
                {feat.desc}
              </p>
              <div className="mt-4 flex flex-wrap gap-2">
                {feat.items.map((item, j) => (
                  <span
                    key={j}
                    className="px-2.5 py-1 rounded-lg bg-secondary-100 text-secondary-700 text-[11px] font-medium"
                  >
                    {item}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}